export const sideBarWidthPercent = 35
export const mobileBreakpoint = 700
export const backgroundColor = '#eee'

export const noselect = `
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
`

export const hideOnMobile = `
  @media (max-width: ${mobileBreakpoint}px) {
    display: none;
  }
` 